import isCheckhq from "Checkhq/isCheckhq";
import { checkhqBaseUrl } from "Checkhq/urls";
import isEveryio from "Everyio/isEveryio";
import isGusto from "Gusto/isGusto";
import isIntuit from "Intuit/isIntuit";
import { intuitBaseUrl } from "Intuit/urls";
import isPrimepay from "Primepay/isPrimepay";
import { primepayBaseUrl } from "Primepay/urls";
import isSquare from "Square/isSquare";
import { squareBaseUrl } from "Square/urls";

/**
 * After going down a bit of a rabbit hole mocking baseUrl for a jest test, I believe that a JS module should only export:
 * 1. functions
 * 2. true constants (naming convention ALL_CAPS)
 */
export const baseUrl = isSquare()
  ? squareBaseUrl
  : isIntuit()
    ? intuitBaseUrl
    : isPrimepay()
      ? primepayBaseUrl
      : isCheckhq()
        ? checkhqBaseUrl
        : isEveryio()
          ? "/everyio/router"
          : isGusto()
            ? "/gusto/router"
            : window.SIPartnerConfiguration?.routerPrefix
              ? `/${window.SIPartnerConfiguration.partner}/router`
              : window.location.pathname.slice(0, 5) === "/zero"
                ? "/zero"
                : "";

export const userSettingsURL = `/account/settings`;
// we use both URL and Url in JS variable names, team-wide we can decide which one to use consistently.
export const supportUrl = "https://support.simplyinsured.com/";

export const calendlyURL = (utm_campaign: string = "quote_page") => {
  const url = "https://calendly.com/simplyinsured-consultation/simplyinsured-health-insurance-consultation";
  const textColor = `text_color=${isIntuit() ? "babec5" : "333333"}`;
  const primaryColor = `primary_color=${isIntuit() ? "393a3d" : "3e69b3"}`;
  const utm = `utm_medium=email&utm_source=simplyinsured&utm_campaign=${utm_campaign}`;
  return `${url}?${textColor}&${primaryColor}&${utm}`;
};

export const calendlyRenewalsURL = (utm_campaign: string = "renewal_page") => {
  const url = "https://calendly.com/simplyinsured-consultation/renewal-consultation";
  const textColor = `text_color=${isIntuit() ? "babec5" : "333333"}`;
  const primaryColor = `primary_color=${isIntuit() ? "393a3d" : "3e69b3"}`;
  const utm = `utm_medium=email&utm_source=simplyinsured&utm_campaign=${utm_campaign}`;
  return `${url}?${textColor}&${primaryColor}&${utm}`;
};

export const calendlyExistingPlanConsultationURL = (utm_campaign: string = "bor_ftu_consult") => {
  const url = "https://calendly.com/bor-connection-team/connect-existing-plan-consultation";
  const textColor = `text_color=${isIntuit() ? "babec5" : "333333"}`;
  const primaryColor = `primary_color=${isIntuit() ? "393a3d" : "3e69b3"}`;
  const utm = `utm_medium=email&utm_source=simplyinsured&utm_campaign=${utm_campaign}`;
  return `${url}?${textColor}&${primaryColor}&${utm}`;
};

export const calendlyConsultationURL = (utm_campaign: string = "large_group_survey") => {
  const url = "https://calendly.com/d/y2f-dw9-h6z/consult-with-simplyinsured";
  const textColor = `text_color=${isIntuit() ? "babec5" : "333333"}`;
  const primaryColor = `primary_color=${isIntuit() ? "393a3d" : "3e69b3"}`;
  const utm = `utm_medium=email&utm_source=simplyinsured&utm_campaign=${utm_campaign}`;
  return `${url}?${textColor}&${primaryColor}&${utm}`;
};

export const calendlyLargeGroupConsultationURL = (utm_campaign: string = "large_group_survey") => {
  const url = "https://calendly.com/simplyinsured-consultation/schedule-a-consultation-large-group";
  const textColor = `text_color=${isIntuit() ? "babec5" : "333333"}`;
  const primaryColor = `primary_color=${isIntuit() ? "393a3d" : "3e69b3"}`;
  const utm = `utm_medium=email&utm_source=simplyinsured&utm_campaign=${utm_campaign}`;
  return `${url}?${textColor}&${primaryColor}&${utm}`;
};
